import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import moment from 'moment'

import { ListCell } from '@src/components/table-list/cells'
import Member from '@src/data/member'
import { computeLastActivityFromAlerts } from '@src/util/functions'

@Component
export class ActivityCell extends ListCell {
  item: Member
  today: moment.Moment
  yesterday: moment.Moment

  constructor () {
    super()
    this.today = moment()
    this.yesterday = moment().subtract(1, 'day')
  }

  render (h: CreateElement) {
    return <div class='cell activity-cell'>
      {this.latestActivity()}
    </div>
  }

  latestActivity () {
    if (!this.item.detailsLoaded) return ''
    let date = this.item.lastActivityDate
    if (!date) {
      return this.$t(computeLastActivityFromAlerts(this.item))
    } else if (this.today.isSame(date, 'day')) {
      return this.$t('PAGE.MEMBERS.LIST.LAST_MEMBER_TRAINING', { lastTrainingDate: this.$t('TODAY') })
    } else if (this.yesterday.isSame(date, 'day')) {
      return this.$t('PAGE.MEMBERS.LIST.LAST_MEMBER_TRAINING', { lastTrainingDate: this.$t('YESTERDAY') })
    } else {
      return this.$t('PAGE.MEMBERS.LIST.LAST_MEMBER_TRAINING', {
        lastTrainingDate: this.$t('N_DAYS_AGO', '', {
          n: this.today.diff(date, 'days')
        })
      })
    }
  }
}
